import { toLowerCase } from 'bl/validation/toLowerCase.bl';

/**
 * @param {Array<{ id: string, value: string }>} optionRows
 * @returns {Set<string>} ids of rows whose trimmed value duplicates another (case-insensitive)
 */
export const getDuplicateOptionIds = (optionRows) => {
  const counts = {};
  optionRows.forEach((row) => {
    const norm = toLowerCase(row.value);
    if (norm) counts[norm] = (counts[norm] || 0) + 1;
  });
  return new Set(
    optionRows
      .filter((row) => {
        const norm = toLowerCase(row.value);
        return norm && counts[norm] > 1;
      })
      .map((row) => row.id),
  );
};
